import { Plugin } from 'jss'
const prefixStyles = (): Plugin => {
  const prefix = Array(4).join(':not(#\\d21)')
  const toIgnore = ['keyframes']

  function onProcessRule(rule: Record<any, any>, styles: any) {
    const parent = rule.options.parent as Record<any, any>
    if (styles?.options?.disablePrefix || rule.type !== 'style' || toIgnore.includes(parent?.type)) return
    rule.selectorText = `${prefix} ${rule.selectorText}`
  }
  return { onProcessRule }
}

export default prefixStyles
